// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__nc30o","disabled":"FileBtn_disabled__1tOb5","warn":"FileBtn_warn__1WHE4","fade":"FileBtn_fade__1-q_S"};